<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('bos.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time3'))">{{ $t('dailyActive.time3') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit">%</div>
            </div>
            <div id="chart-box"></div>
            <div class="legend-box" v-if="activeTime == 0&&this.$i18n.locale=='zh'">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-text1 legend-text">{{$t('bos.level0')}}</div>
                <div class="legend-text2 legend-text">{{$t('bos.level1')}}</div>
                <div class="legend-text3 legend-text">{{$t('bos.level2')}}</div>
            </div>
            <div class="legend-box" v-if="activeTime == 0&&this.$i18n.locale=='en'">
                <div class="legend-bar4 legend-bar"></div>
                <div class="legend-bar5 legend-bar"></div>
                <div class="legend-bar6 legend-bar"></div>
                <div class="legend-text4 legend-text">{{$t('bos.level0')}}</div>
                <div class="legend-text5 legend-text">{{$t('bos.level1')}}</div>
                <div class="legend-text6 legend-text">{{$t('bos.level2')}}</div>
            </div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}<span class="math-text"
                                                                                                  v-if="mathData.maxData"> %</span>
                        </div>
                        <div class="math-text">{{$t('bos.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}<span class="math-text"
                                                                                                  v-if="mathData.minData"> %</span>
                        </div>
                        <div class="math-text">{{$t('bos.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}<span class="math-text"
                                                                                                  v-if="mathData.avgData"> %</span>
                        </div>
                        <div class="math-text">{{$t('bos.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title"> {{$t('bos.descTitle')}}</div>
            <div class="desc-info desc-last">
                {{$t('bos.desc0')}}
                <br>
                {{$t('bos.desc1')}}
                <br>
                {{$t('bos.desc2')}}
                <br>
                {{$t('bos.desc3')}}
                <br>
                {{$t('bos.desc4')}}
                <br>
                {{$t('bos.desc5')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'bos',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                tNum: 0,
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                bosInfo: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('bos.time0');
            this.startDate = getToday();
            this.endDate = getToday();
            this.time = getToday().slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.tNum <= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 2 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.tNum++;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.tNum > 0) {
                    this.tNum--;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 1) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 2) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                if (this.activeTime == 0) {
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 3) {
                    this.time = GetYear(this.yNum) + '年';
                }
                this.getData();
            },
            getData() {
                this.checkOpacity()
                this.mathData = {}
                if (this.activeTime == 0) {
                    this.$api.status.getBos({
                        date: this.startDate
                    }).then(res => {
                        if (res.result == 1) {
                            this.mathData.maxData = res.info.bosMax;
                            this.mathData.avgData = res.info.bosAvg;
                            this.mathData.minData = res.info.bosMin;
                            this.bosInfo = res.info;
                            this.$nextTick(function () {
                                this.drawDayChart()
                                this.$forceUpdate()
                            })
                        }
                    })
                } else {
                    this.$api.status.getBos({
                        startDate: this.startDate,
                        endDate: this.endDate
                    }).then(res => {
                        if (res.result == 1) {
                            this.bosInfo = res.info
                            this.mathData.maxData = res.info.maxBos;
                            this.mathData.avgData = res.info.avgBos;
                            this.mathData.minData = res.info.minBos;
                            this.bosInfo.dateArr = [];
                            this.bosInfo.dataMinArr = [];
                            this.bosInfo.dataMaxArr = [];
                            this.bosInfo.dataBasicArr = [];
                            for (let i = 0; i < this.bosInfo.dataBos.length; i++) {
                                this.bosInfo.dateArr.push(this.bosInfo.dataBos[i].date);
                                if (this.bosInfo.dataBos[i].bosMin == this.bosInfo.dataBos[i].bosMax && this.bosInfo.dataBos[i].bosMin > 0) {
                                    this.bosInfo.dataMaxArr.push(0.9);
                                } else {
                                    this.bosInfo.dataMaxArr.push(this.bosInfo.dataBos[i].bosMax - this.bosInfo.dataBos[i].bosMin);
                                }
                                this.bosInfo.dataMinArr.push(this.bosInfo.dataBos[i].bosMin);

                            }
                            this.$nextTick(function () {
                                this.drawChart()
                                this.$forceUpdate()
                            })
                        }
                    })
                }
            },
            drawDayChart() {
                let _this = this;
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            min: 60,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    let data = this.bosInfo.bosData.split(',');
                    let data_style = []
                    for (let i = 0; i < data.length; i++) {
                        let color;
                        if (data[i] >= 95) {
                            color = getSkin('--chart-color-3')
                        } else if (data[i] >= 90) {
                            color = getSkin('--chart-color-8')
                        } else {
                            color = getSkin('--chart-color-10')
                        }
                        let style = {
                            value: data[i],
                            itemStyle: {
                                color: color
                            },
                            emphasis: {
                                itemStyle: {
                                    borderColor: color,
                                    borderWidth: 1.5 * this.ratio,
                                    color: 'transparent'
                                }
                            }
                        }
                        data_style.push(style)
                    }
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> %</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            min: 60,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 9 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: data_style,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            },
            drawChart() {
                let _this = this;
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let barWidth = 10 * this.ratio;
                if (this.activeTime == 1) {
                    barWidth = 10 * this.ratio;
                } else {
                    barWidth = 4 * this.ratio;
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.bosInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            min: 60,
                            max: 100,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                name: '血氧饱和度',
                                showSymbol: false,
                                itemStyle: {
                                    color: getSkin('--chart-color-7'),
                                },
                                data: [0],
                                type: 'line',
                                lineStyle: {
                                    width: 2,
                                }
                            }
                        ]
                    }, true);
                } else {
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let minData = params[0].data ? params[0].data : 0;
                                let maxData = params[1].data ? params[1].data : 0;
                                if (maxData == 0.9) {
                                    maxData = 0
                                }
                                maxData = maxData + minData;
                                if (minData == 0 && maxData == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;margin-bottom: 2px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + minData + '~' + maxData + '</span> %</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.bosInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            min: 60,
                            max: 100,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            },
                        },
                        series: [
                            {
                                name: '最低血氧饱和度',
                                type: 'bar',
                                stack: 'Total',
                                silent: true,
                                itemStyle: {
                                    borderColor: 'transparent',
                                    color: 'transparent'
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: 'transparent',
                                        color: 'transparent'
                                    }
                                },
                                barWidth: barWidth,
                                data: this.bosInfo.dataMinArr
                            },
                            {
                                name: '血氧饱和度',
                                type: 'bar',
                                stack: 'Total',
                                barWidth: barWidth,
                                itemStyle: {
                                    color: getSkin('--chart-color-3'),
                                    //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                                    borderRadius: [10, 10, 10, 10]
                                },
                                emphasis: {
                                    itemStyle: {
                                        color: getSkin('--chart-color-4')
                                    }
                                },
                                data: this.bosInfo.dataMaxArr
                            },
                        ]
                    }, true);
                }
            },
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 198px;
        width: 100%;
    }

    .chart-unit {
        position: absolute;
        font-size: 11px;
        color: var(--text-color-3);
        left: 23px;
        top: 20px;
    }

    .legend-box {
        width: 100%;
        height: 30px;
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-3);
        left: 41px;
        top: 4px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-8);
        left: 152px;
        top: 4px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-10);
        left: 290px;
        top: 4px;
    }

    .legend-bar4 {
        background-color: var(--chart-color-3);
        left: 15px;
        top: 4px;
    }

    .legend-bar5 {
        background-color: var(--chart-color-8);
        left: 85px;
        top: 4px;
    }

    .legend-bar6 {
        background-color: var(--chart-color-10);
        left: 215px;
        top: 4px;
    }

    .legend-text {
        position: absolute;
        font-size: 10px;
        color: var(--text-color-2);
    }

    .legend-text1 {
        top: 0;
        left: 54px;
    }

    .legend-text2 {
        top: 0;
        left: 165px;
    }

    .legend-text3 {
        top: 0;
        left: 303px;
    }

    .legend-text4 {
        top: 0;
        left: 30px;
    }

    .legend-text5 {
        top: 0;
        left: 100px;
    }

    .legend-text6 {
        top: 0;
        left: 230px;
    }

    .math-box {
        width: 345px;
        height: 66px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 0px auto 10px;
    }

</style>



// WEBPACK FOOTER //
// src/views/status/08bos.vue